import React, { useEffect } from "react";
import "../../Style/LookupModal.css";

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  footer?: React.ReactNode;
  children?: React.ReactNode;
}

// Shell for the related-ticket lookups: header, scrollable body, sticky footer
const TaskModal: React.FC<ModalProps> = ({
                                           isOpen,
                                           onClose,
                                           title,
                                           subtitle,
                                           footer,
                                           children,
                                         }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
      <div className="lk-overlay" onMouseDown={onClose}>
        <div
            className="lk-panel"
            role="dialog"
            aria-modal="true"
            onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="lk-header">
            <div>
              {title && <h2>{title}</h2>}
              {subtitle && <p>{subtitle}</p>}
            </div>
            <button
                type="button"
                onClick={onClose}
                className="lk-close"
                aria-label="Close"
            >
              ×
            </button>
          </div>
          <div className="lk-body">{children}</div>
          {footer && <div className="lk-footer">{footer}</div>}
        </div>
      </div>
  );
};

export default TaskModal;
